import React, { useEffect, useState } from 'react';
import { buildLegacyFileUrl, getPresignedFileUrl } from '../../services/fileUrlService';

/**
 * Anchor that resolves fileKey to a presigned (or legacy) URL on mount.
 */
const PresignedLink = ({
  fileKey,
  children,
  className,
  download = false,
  originalName,
  target = '_blank',
  rel = 'noopener noreferrer',
  onClick,
  title,
}) => {
  const [href, setHref] = useState(null);
  const [legacyTried, setLegacyTried] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!fileKey) return undefined;
    setLegacyTried(false);
    const opts = {};
    if (download) opts.download = true;
    if (originalName) opts.originalName = originalName;
    (async () => {
      const url = await getPresignedFileUrl(fileKey, opts);
      if (!cancelled && url) setHref(url);
    })();
    return () => {
      cancelled = true;
    };
  }, [fileKey, download, originalName]);

  if (!fileKey) return null;

  if (!href) {
    return (
      <span className={className} aria-busy="true">
        {children}
      </span>
    );
  }

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (legacyTried || !href) return;
    try {
      const hrefUrl = new URL(href);
      const apiOrigin = new URL(buildLegacyFileUrl(fileKey, { download, originalName })).origin;
      if (hrefUrl.origin === apiOrigin) return;
    } catch (_) {
      // ignore URL parsing errors
    }
    const legacyUrl = buildLegacyFileUrl(fileKey, { download, originalName });
    if (legacyUrl && legacyUrl !== href) {
      setLegacyTried(true);
      setHref(legacyUrl);
    }
  };

  return (
    <a href={href} className={className} target={target} rel={rel} onClick={handleClick} title={title}>
      {children}
    </a>
  );
};

export default PresignedLink;
